import {defineMessages} from 'react-intl';

const messages = defineMessages({
    TICKET_NUMBER: {
        id: 'ase.export.form.ticketNumber',
        defaultMessage: 'Ticket No.'
    },
    DATE_FROM: {
        id: 'ase.export.form.dateFrom',
        defaultMessage: 'Date From'
    },
    DATE_TO: {
        id: 'ase.export.form.dateTo',
        defaultMessage: 'Date To'
    },
    ASSIGNED: {
        id: 'ase.export.form.assigned',
        defaultMessage: 'Assigned to'
    },
    STATUS: {
        id: 'ase.export.form.status',
        defaultMessage: 'Status'
    },
    SOLUTION_GROUP: {
        id: 'ase.export.form.solutionGroup',
        defaultMessage: 'Solution Group'
    },
    DEALER_NUMBER: {
        id: 'ase.export.form.dealerNumber',
        defaultMessage: 'Dealer No.'
    },
    DEALER_NAME: {
        id: 'ase.export.form.dealerName',
        defaultMessage: 'Dealer Name'
    },
    TYPE: {
        id: 'ase.export.form.type',
        defaultMessage: 'Type'
    },
    XLS: {
        id: 'ase.export.form.xls',
        defaultMessage: 'XLS'
    },
    CSV: {
        id: 'ase.export.form.csv',
        defaultMessage: 'CSV'
    },
    EXPORT_STATUS: {
        id: 'ase.export.exportStatus',
        defaultMessage: 'Export status:'
    },
    LAST_EXPORT: {
        id: 'ase.export.lastExport',
        defaultMessage: 'Last export:'
    },
    FORMTYPE: {
        id: 'ase.export.formType',
        defaultMessage: 'Type of Request'
    },
    VEHICLE_FAMILY: {
        id: 'ase.export.vehicleFamily',
        defaultMessage: 'Vehicle Family'
    }
});

export default messages;
